/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { User } from './user';
import type { ReportIdNameReference } from './reportIdNameReference';

export type SubmissionRecordStudent = User | ReportIdNameReference;
